import React from 'react';
import TopRowTitle from '../TopRowTitle';
import { Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import YesOrNoFormField from '@rd-web-markets/shared/dist/util/form_fields/YesOrNoFormField';
import { makeKey } from '@rd-web-markets/shared/dist/hooks/useConvertForTranslationKey';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
const ProjectDetailRow = _ref => {
  let {
    rowData,
    index,
    updateState,
    projectDetails,
    disabled = false,
    label,
    rowClass = '',
    tooltipText = ''
  } = _ref;
  const {
    t
  } = useTranslation();
  const renderInput = function (field, index) {
    let type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'decimal';
    if (type === 'decimal') {
      return /*#__PURE__*/React.createElement(ChangeHighlighter, {
        as: FormattedNumberInput,
        thousandSeparator: ".",
        decimalSeparator: ",",
        object: field,
        name: 1,
        type: "text",
        size: "sm",
        disabled: disabled,
        onlyPositiveNumbers: true,
        onChange: e => updateState({
          target: {
            value: e.target.value
          }
        }, projectDetails, field[0]),
        style: {
          width: '100px'
        }
      });
    } else if (type === 'boolean') {
      return /*#__PURE__*/React.createElement("div", {
        key: field[0] + 'affiliateYesOrNo',
        className: "mt-3"
      }, /*#__PURE__*/React.createElement(YesOrNoFormField, {
        labelText: t(field[0]),
        formName: 'projectDetail' + index,
        checkedField: field[1],
        onChange: updateState,
        onChangeParams: [projectDetails, field[0]]
      }));
    }
  };
  return /*#__PURE__*/React.createElement("div", null, rowData[0] === 'iihrde_number_of_times_associated' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t(makeKey('Information on in-house R & D expenditure'))
  }), rowData[0] === 'ocsp_working_hours' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t(makeKey('Own contribution of a sole proprietor to this R & D project'))
  }), rowData[0] === 'ocsce_is_civil_agreement' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t(makeKey('Own contribution of shareholders of a co-entrepreneurship to this R&D project'))
  }), rowData[0] === 'ic_rd_project_will_carried_with_affiliated_companies' && /*#__PURE__*/React.createElement(TopRowTitle, {
    title: t(makeKey('Information on cooperations)'))
  }), rowData[1] === true || rowData[1] === false ? renderInput(rowData, index, 'boolean') : /*#__PURE__*/React.createElement(Row, {
    className: rowClass
  }, /*#__PURE__*/React.createElement(Col, {
    md: 7
  }, /*#__PURE__*/React.createElement("p", null, label || t(rowData[0]))), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, !!tooltipText.length ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "top",
    overlay: /*#__PURE__*/React.createElement(Tooltip, null, tooltipText)
  }, /*#__PURE__*/React.createElement("div", null, renderInput(rowData, index, 'decimal'))) : renderInput(rowData, index, 'decimal')), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, rowData[0] === 'iihrde_number_of_times_associated' && /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: () => {},
    className: "ms-auto me-3"
  }, t('manual_update')))));
};
export default ProjectDetailRow;